///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

export const datRatesMockData = {
  transaction: "edca7e87-44df-4fe2-b952-3e09a5cb2dea",
  created: "2023-05-09T12:37:44.024Z",
  rateResponses: [
    {
      response: {
        rate: {
          mileage: 1,
          reports: 212,
          companies: 29,
          standardDeviation: 140.56,
          perMile: null,
          averageFuelSurchargePerMileUsd: 0,
          perTrip: {
            rateUsd: 318.41,
            highUsd: 433.26,
            lowUsd: 224.49
          },
          averageFuelSurchargePerTripUsd: 0.45
        },
        escalation: {
          timeframe: "90_DAYS",
          origin: {
            name: "606xx",
            type: "3_DIGIT_ZIP"
          },
          destination: {
            name: "606xx",
            type: "3_DIGIT_ZIP"
          }
        },
        errors: []
      },
      request: {
        origin: {
          city: "Chicago",
          postalCode: "60607",
          stateOrProvince: "IL"
        },
        destination: {
          city: "Chicago",
          postalCode: "60607",
          stateOrProvince: "IL"
        },
        targetEscalation: {
          escalationType: "SPECIFIC_AREA_TYPE_AND_SPECIFIC_TIME_FRAME",
          specificTimeFrame: "90_DAYS",
          specificAreaType: "3_DIGIT_ZIP"
        },
        rateType: "SPOT",
        equipment: "VAN",
        includeMyRate: false
      }
    },
    {
      response: {
        rate: {
          mileage: 1,
          reports: 330,
          companies: 6,
          standardDeviation: 171.8,
          perMile: null,
          averageFuelSurchargePerMileUsd: 0,
          perTrip: {
            rateUsd: 338.31,
            highUsd: 338.32,
            lowUsd: 113.18
          },
          averageFuelSurchargePerTripUsd: 0.45
        },
        escalation: {
          timeframe: "90_DAYS",
          origin: {
            name: "606xx",
            type: "3_DIGIT_ZIP"
          },
          destination: {
            name: "606xx",
            type: "3_DIGIT_ZIP"
          }
        },
        errors: []
      },
      request: {
        origin: {
          city: "Chicago",
          postalCode: "60607",
          stateOrProvince: "IL"
        },
        destination: {
          city: "Chicago",
          postalCode: "60607",
          stateOrProvince: "IL"
        },
        targetEscalation: {
          escalationType: "SPECIFIC_AREA_TYPE_AND_SPECIFIC_TIME_FRAME",
          specificTimeFrame: "90_DAYS",
          specificAreaType: "3_DIGIT_ZIP"
        },
        rateType: "CONTRACT",
        equipment: "VAN",
        includeMyRate: false
      }
    }
  ]
};

export const datRatesHammondCiceroMockData = {
  transaction: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
  created: "2023-03-07T12:00:00.000Z",
  rateResponses: [
    {
      response: {
        rate: {
          mileage: 30,
          reports: 48,
          companies: 12,
          standardDeviation: 85.2,
          perMile: null,
          averageFuelSurchargePerMileUsd: 0,
          perTrip: {
            rateUsd: 425,
            highUsd: 520,
            lowUsd: 310
          },
          averageFuelSurchargePerTripUsd: 0.5
        },
        escalation: {
          timeframe: "90_DAYS",
          origin: {
            name: "463xx",
            type: "3_DIGIT_ZIP"
          },
          destination: {
            name: "608xx",
            type: "3_DIGIT_ZIP"
          }
        },
        errors: []
      },
      request: {
        origin: {
          city: "Hammond",
          postalCode: "46320",
          stateOrProvince: "IN"
        },
        destination: {
          city: "Cicero",
          postalCode: "60804",
          stateOrProvince: "IL"
        },
        targetEscalation: {
          escalationType: "SPECIFIC_AREA_TYPE_AND_SPECIFIC_TIME_FRAME",
          specificTimeFrame: "90_DAYS",
          specificAreaType: "3_DIGIT_ZIP"
        },
        rateType: "SPOT",
        equipment: "VAN",
        includeMyRate: false
      }
    },
    {
      response: {
        rate: {
          mileage: 30,
          reports: 62,
          companies: 8,
          standardDeviation: 92.4,
          perMile: null,
          averageFuelSurchargePerMileUsd: 0,
          perTrip: {
            rateUsd: 445,
            highUsd: 540,
            lowUsd: 330
          },
          averageFuelSurchargePerTripUsd: 0.5
        },
        escalation: {
          timeframe: "90_DAYS",
          origin: {
            name: "463xx",
            type: "3_DIGIT_ZIP"
          },
          destination: {
            name: "608xx",
            type: "3_DIGIT_ZIP"
          }
        },
        errors: []
      },
      request: {
        origin: {
          city: "Hammond",
          postalCode: "46320",
          stateOrProvince: "IN"
        },
        destination: {
          city: "Cicero",
          postalCode: "60804",
          stateOrProvince: "IL"
        },
        targetEscalation: {
          escalationType: "SPECIFIC_AREA_TYPE_AND_SPECIFIC_TIME_FRAME",
          specificTimeFrame: "90_DAYS",
          specificAreaType: "3_DIGIT_ZIP"
        },
        rateType: "CONTRACT",
        equipment: "VAN",
        includeMyRate: false
      }
    }
  ]
};
